
import React, { useCallback, useState, useEffect } from "react";
import { sendEmail } from "../utils/sendEmail";
import moment from "moment";
import { OverdueInvoice } from "../api/overdueInvoiceUtils";
import { getInvoicesData } from "../api/finance-api";

const OverdueEmail: React.FC = () => {
    const [overdueList, setOverdueList] = useState<OverdueInvoice[]>([]);
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        async function fetchOverdue() {
            setLoading(true);
            const filters = { employee: "" };
            const data = await getInvoicesData(filters);
            const overdue = data.filter((row: any) => {
                if (!row.invoice_no || row.diff === undefined || !(row.diff > 0) || !row._ts_invoice_due) return false;
                const dueDate = moment(row._d);
                const minDate = moment("2025-01-01");
                if (dueDate.isBefore(minDate, "day")) return false;
                const days = moment().diff(dueDate, "days");
                return days >= 0;
            });
            setOverdueList(overdue);
            setLoading(false);
        }
        fetchOverdue();
    }, []);

    const handleSendEmail = useCallback(async () => {
        if (loading) return;
        setSending(true);
        const htmlTable =
            overdueList.length > 0
                ? `<table border="1" cellpadding="5" style="border-collapse:collapse;">
                        <thead><tr><th>Name</th><th>Invoice No</th><th>Days Overdue</th><th>Project</th><th>Billing Period</th><th>Month</th><th style='text-align:right;'>Amount</th><th>Due Date</th></tr></thead>
                        <tbody>
                            ${overdueList
                                .map((inv) => {
                                    if (!inv.invoice_no || inv.diff === undefined || !(inv.diff > 0)) return "";
                                    const dueDate = inv._ts_invoice_due;
                                    if (!dueDate) return "";
                                    const days = moment().diff(moment(dueDate), "days");
                                    const isOverdue = days >= 0;
                                    if (!isOverdue) return "";
                                    const daysText = `<span style='color:red;'>${days} day${days === 1 ? "" : "s"}</span>`;
                                    return `<tr><td>${inv.name}</td><td>${inv.invoice_no}</td><td>${daysText}</td><td>${inv.project_name}</td><td>${inv.billing_period || '-'}</td><td>${inv.month1 ? `${inv.month1} ${inv.year}` : '-'}</td><td style='text-align:right;'>$ ${Number(inv.diff).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td><td>${moment(inv._ts_invoice_due).format("YYYY-MM-DD")}</td></tr>`;
                                })
                                .join("")}
                        </tbody>
                </table>`
                : "<p>No overdue invoices.</p>";
        await sendEmail({
            to: ["accounts@mindtechinc.com"],
            subject: "Overdue Invoice List",
            message: `<p>Here is the list of overdue invoices:</p>${htmlTable}`,
        });
        setSending(false);
    }, [overdueList, loading]);

    return (
        <button onClick={handleSendEmail} disabled={sending || loading} className="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 disabled:opacity-50">
            {loading ? "Loading..." : sending ? "Sending..." : "Send Overdue Invoice List"}
        </button>
    );
};

export default OverdueEmail;
